var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"myChart",staticClass:"bg",style:({ width: '100%', height: _vm.height }),attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }